import axios from '../axios';

export default class ValidateUser {
  async leaderRelease(loginUser, phone) {
    let res = await axios.get(`/Services/leaderRelease?user=${loginUser}&phone=${phone}`);
    return res.data;
  }

  async addTechnicanPhone(loginUser, phone) {
    let res = await axios.post(`/Services/saveLeaderInformation?login=${loginUser}&phone=55${phone}`);
    return res.data;
  }

  async verifyIsLeader(loginUser, phone) {
    let res = await axios.get(`/Services/leaderRelease?user=${loginUser}&phone=11111111111`);
    return res.data;
  }

  async verifyIsLeader(loginUser) {
    let res = await axios.get(`/Services/checkLeaderLogin?login=${loginUser}`);
    return res.data;
  }

  async getOs(loginUser, phone) {
    // let res = await axios.get("/v1/Services/leaderRelease/");
    // return res.data;
  }

}